export enum CAUSES_INCIDENCE_PERMISSIONS {
  CAUSES_INCIDENCE_VIEW = 'INCIDENCE_CAUSESVIEW',
  CAUSES_INCIDENCE_WRITE = 'INCIDENCE_CAUSESWRITE',
}
